import React, { useEffect } from 'react';
import Api from '../api/Api';
import Logger from '../utils/Logger';
import Loader from '../components/Loader';
import jwt_decode from 'jwt-decode';

const { id: module_id } = module;
const logger = Logger(module_id);

const defaultState = {
  accessToken: null,
  accessTokenExpiry: null,
  accessTokenIssuedAt: null,
  getAccessToken: async () => {
    throw Error('AccessTokenContext not initialized');
  },
  isInitialized: false,
};

export const AccessTokenContext = React.createContext(defaultState);
const AccessTokenContextProvider = ({ children }) => {
  const [accessTokenState, setAccessTokenState] = React.useState(defaultState);

  const getAccessToken = async () => {
    try {
      const { access_token } = await Api.getAccessToken();
      if (access_token) {
        const decoded = jwt_decode(access_token);
        setAccessTokenState({
          accessToken: access_token,
          accessTokenExpiry: decoded.exp,
          accessTokenIssuedAt: decoded.iat,
          getAccessToken,
          isInitialized: true,
        });
      }
    } catch (error) {
      logger.error(error);
    }
  };
  
  const accessTokenExpiryTimer = React.useRef();

  // Set timer for expiry of access token and renew
  useEffect(() => {
    if (accessTokenState.isInitialized) {
      // expiry time is in unix format, need to change to Date
      const expiryDate = new Date(accessTokenState.accessTokenExpiry) * 1000
      const accessTokenExpiryInMilliseconds = expiryDate - new Date().getTime();
      accessTokenExpiryTimer.current = setTimeout(() => {
        getAccessToken()
       }, accessTokenExpiryInMilliseconds);
      return () => clearInterval(accessTokenExpiryTimer.current);
    }
  }, [accessTokenState.accessTokenExpiry, accessTokenState.isInitialized]);

  useEffect(() => {
    getAccessToken();
  }, []);


  return (
    <AccessTokenContext.Provider value={accessTokenState}>
      {accessTokenState.isInitialized ? children : <Loader />}
    </AccessTokenContext.Provider>
  );
};

export default AccessTokenContextProvider;
